import API from '@/helpers/api';

export async function find(params = {}) {
  return API('/insurances', params).fetch();
}

export async function findById(id) {
  return API(`/insurances/${id}`).fetch();
}
